import axios from 'axios'
// import { store } from '@/config/router'
import message from '@/components/MessageWithClose/MessageWithClose'

export interface reqConfType {
	[key: string]: string;
}
export interface reqErrType {
	[key: string]: string;
}
export interface resConfType {
	status: number;
	data: {
		msg: string,
		error: string,
	};
}
export interface resErrType {
	response: {
		status: number,
		statusText: string,
	};
}
export interface axiosConfType {
	timeout: number
	headers: {
		[key: string]: string
	}
	withCredentials: boolean
	crossDomain: boolean
	adapter?: any
	reqConf?: reqConfType
	resConf?: resConfType
	reqErr?: reqErrType
	resErr?: resErrType
}

let logoutTimer: any = null // 登出延时器,防止同时多个请求多个弹框
export class Instance {
	instance: any
	constructor(axiosConf: axiosConfType) {
		this.instance = axios.create(axiosConf)
		this.initInterceptors()
	}
	getInstance() {
		return this.instance
	}
	initInterceptors() {
		const { interceptors } = this.instance
		interceptors.request.use(
			(conf: reqConfType): reqConfType => {
				// 请求配置拦截
				conf.headers['token'] = sessionStorage.getItem('token')
				return conf
			},
			(err: reqErrType): any => {
				// 请求报错拦截
				return Promise.reject(err)
			}
		)
		interceptors.response.use(
			(res: resConfType): Promise<any> => {
				// 如果返回的状态码为200，说明接口请求成功,否则的话抛出错误
				// console.log(res)
				if (res.status === 200) {
					return Promise.resolve(res.data)
				} else {
					return Promise.reject(res)
				}
			},
			// 服务器状态码不是2开头的的情况,然后根据返回的状态码进行一些操作：403token无效则自动退出
			async (err: resErrType): Promise<any> => {
				// console.log(err)
				// 401无效的token、 403越权访问
				if (err.response.status === 401) {
					// if (logoutTimer) {
					// 	return
					// }
					// logoutTimer = setTimeout(async () => {
					// 	message.error('登录超时,请重新登录！')
					// 	await store.dispatch('logout', false)
					// 	clearTimeout(logoutTimer)
					// }, 1500)
				}
				if (err.response.status === 403) {
					return message.error('越权操作')
				}
				return Promise.reject(err)
			}
		)
	}
}

export default new Instance({
	timeout: 20000,
	headers: {
		'X-Requested-With': 'XMLHttpRequest',
	},
	withCredentials: true,
	crossDomain: true,
}).getInstance()
